module.exports = __webpack_public_path__ + "img/gallery-6.0c171bcb.webp";